import { render, staticRenderFns } from "./BPDefinitionList.vue?vue&type=template&id=61553199&"
import script from "./BPDefinitionList.vue?vue&type=script&lang=js&"
export * from "./BPDefinitionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports